// หน้าคัฟเวอร์สำหรับไฟล์ PDF ที่ผู้ใช้สั่งพิมพ์จากหน้าเครื่องมือ
// แสดงเฉพาะตอนพิมพ์ (print-only) และถูกบังคับขึ้นหน้าใหม่หลังจบคัฟเวอร์
interface Props {
  title: string;
  purpose?: string;
  destination?: string;
  routeLabel?: string;
  /** เช็กลิสต์แบบสั้น 3–8 บรรทัด */
  checklist: string[];
  /** ข้อความสรุปเพิ่มเติม เช่น ระยะเวลารวมโดยประมาณ */
  summary?: string;
}

function today() {
  const d = new Date();
  return d.toLocaleDateString("th-TH", { year: "numeric", month: "long", day: "numeric" });
}

export default function PrintCoverSheet({
  title,
  purpose,
  destination,
  routeLabel,
  checklist,
  summary,
}: Props) {
  return (
    <section className="print-cover" data-print-cover aria-hidden="true">
      <div className="print-cover-brand">NYC Legal &amp; Language Institute</div>
      <h1 className="print-cover-title">{title}</h1>
      <dl className="print-cover-meta">
        {purpose && (
          <>
            <dt>วัตถุประสงค์</dt>
            <dd>{purpose}</dd>
          </>
        )}
        {destination && (
          <>
            <dt>ปลายทาง</dt>
            <dd>{destination}</dd>
          </>
        )}
        {routeLabel && (
          <>
            <dt>เส้นทางรับรอง</dt>
            <dd>{routeLabel}</dd>
          </>
        )}
        <dt>วันที่สร้างไฟล์</dt>
        <dd>{today()}</dd>
      </dl>
      {summary && <p className="print-cover-summary">{summary}</p>}
      <h2 className="print-cover-h2">เช็กลิสต์แบบสั้น</h2>
      <ul className="print-cover-list">
        {checklist.slice(0, 8).map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <p className="print-cover-foot">
        เอกสารนี้เป็นแนวทางเริ่มต้น ไม่ใช่การรับประกันผล — ควรตรวจสอบเช็กลิสต์ล่าสุดของหน่วยงานปลายทางประกอบเสมอ ·
        nyclanguageinstitute.com · โทร 083-249-4999
      </p>
    </section>
  );
}
